import React from "react";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {ContentProvider} from "./ContentContext";
// Components
import {Layout, ScrollToTop} from "./components/layout/index";
// Modules
import {Extras, FAQ, Gallery, Info, Partner, Services, Tours} from "./components/modules/index";
// Routes
import {About, DataProtection, Imprint} from "./routes/index";
// Styling
import "./scss/main.scss";

function App() {
    return (
        <ContentProvider>
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    {/* Homepage */}
                    <Route
                        path="/"
                        element={
                            <Layout headerImage>
                                <Info />
                                <Services />
                                <div className={"full-width-background"}>
                                    <img
                                        className={"background-image"}
                                        src={"/assets/background.png"}
                                        alt={"Background decoration"}
                                        loading={"lazy"}
                                    />
                                    <Tours />
                                    <Gallery />
                                </div>
                                <Extras />
                                <Partner />
                                <FAQ />
                            </Layout>
                        }
                    />
                    {/* About */}
                    <Route
                        path="/über-mich"
                        element={
                            <Layout route routeId={"about"}>
                                <About />
                            </Layout>
                        }
                    />
                    {/* Imprint */}
                    <Route
                        path="/impressum"
                        element={
                            <Layout route routeId={"imprint"}>
                                <Imprint />
                            </Layout>
                        }
                    />
                    {/* Data Protection */}
                    <Route
                        path="/datenschutz"
                        element={
                            <Layout route routeId={"data-protection"}>
                                <DataProtection />
                            </Layout>
                        }
                    />
                </Routes>
            </BrowserRouter>
        </ContentProvider>
    );
}

export default App;
